<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content *ngIf="!isLoading">
  <h1 [ngStyle]="{ 'margin-bottom': pageURL === '/tabs/performance' ? '15px' : '' }">{{ companyDetail.name }}</h1>
  <p class="sub-title" *ngIf="pageURL !== '/tabs/performance'">{{ companyDetail.stock_ratio | percent: '1.0-1' }}</p>
  <div class="company-image" *ngIf="companyDetail.logo" [ngStyle]="getCompanyCoverImage(companyDetail)">
    <img class="logo" [src]="companyDetail.logo" />
    <div class="company-image__wished" *ngIf="!isEve2 && companyDetail.is_wishlist">
      <ion-icon name="hearts"></ion-icon>
    </div>
  </div>
  <div class="company-image__wished company-image__wished-standalone" *ngIf="!isEve2 && companyDetail.is_wishlist && !companyDetail.logo">
    <ion-icon name="hearts"></ion-icon>
  </div>
  <div class="company-topics">
    <img *ngFor="let topic of companyDetail.topics" [src]="topic.icon" (click)="openTopicDetail(topic)" />
    <img src="/assets/icon/stability.svg" *ngIf="!isEve2 && companyDetail.topics?.length === 0" (click)="openTopicDetail(getStabilityPositionObject())" />
  </div>
  <div class="company__warning" *ngIf="!isEve2 && !companyDetail.stock_ratio">
    <ion-icon name="warning-triangle"></ion-icon>
    <p>{{ 'STRATEGY.stocks.companyDescription.stockRatio.zero' | translate }}</p>
  </div>
  <div>
    <p class="category-title">{{ 'STRATEGY.stocks.description.title1' | translate }}</p>
    <div class="company__infos">
      <div class="company__info">
        <ion-icon name="location"></ion-icon>
        <span>{{ companyDetail.based }}</span>
      </div>
      <div class="company__info">
        <ion-icon name="sector"></ion-icon>
        <span>{{ getCompanySector(companyDetail) | translate }}</span>
      </div>
      <div class="company__info">
        <ion-icon name="globe"></ion-icon>
        <span>
          <a href="{{ companyDetail.link }}" target="_blank">{{ companyDetail.link_string }}</a>
        </span>
      </div>
    </div>
  </div>
  <p class="company__desc" [innerHTML]="companyDetail.desc"></p>
  <p
    class="company__extra-desc"
    *ngIf="companyDetail.good_bullet_points?.length === 0 && companyDetail.bad_bullet_points?.length === 0 && companyDetail.extra_desc"
    [innerHTML]="companyDetail.extra_desc"
  ></p>
  <div class="company__additional-topics" *ngIf="!isEve2 && companyDetail.additional_topics?.length">
    <p>
      {{
        (companyDetail.is_balance ? 'STRATEGY.stocks.description.additionalTopics' : 'STRATEGY.stocks.description.additionalTopicsStability')
          | translate
      }}
    </p>
    <div class="company-topics">
      <img *ngFor="let topic of companyDetail.additional_topics" [src]="topic.icon" (click)="openTopicDetail(topic)" />
    </div>
  </div>
  <div class="company__conflicts" *ngIf="!isEve2 && companyDetail.criteria_dismatch?.length">
    <div class="company__conflicts-top">
      <ion-icon name="warning-triangle"></ion-icon>
      <span>{{ 'STRATEGY.stocks.description.exclusionsClash' | translate }}</span>
    </div>
    <div class="company__conflicts-down">
      <div class="company-topics">
        <img *ngFor="let topic of companyDetail.criteria_dismatch" [src]="topic.icon" (click)="openTopicDetail(topic)" />
      </div>
    </div>
  </div>
  <div class="company__list" *ngIf="companyDetail.good_bullet_points?.length">
    <p class="category-title">{{ 'STRATEGY.stocks.description.title2' | translate }}</p>
    <div class="company__list-item" *ngFor="let item of companyDetail.good_bullet_points">
      <ion-icon name="checkmark-circle"></ion-icon>
      <span>{{ item }}</span>
    </div>
  </div>
  <div class="company__list" *ngIf="companyDetail.bad_bullet_points?.length">
    <p class="category-title">{{ 'STRATEGY.stocks.description.title3' | translate }}</p>
    <div class="company__list-item company__list-item--warning" *ngFor="let item of companyDetail.bad_bullet_points">
      <ion-icon name="alert-circle"></ion-icon>
      <span>{{ item }}</span>
    </div>
  </div>
</ion-content>

<ion-content *ngIf="isLoading">
  <div class="skeleton-title">
    <ion-skeleton-text animated></ion-skeleton-text>
  </div>
  <div class="company-logo">
    <div class="skeleton-image logo"></div>
  </div>
  <div class="skeleton-image illustrative"></div>
  <ion-row class="ion-no-margin">
    <ion-col class="ion-no-padding">
      <p>
        <ion-skeleton-text animated></ion-skeleton-text>
      </p>
    </ion-col>
    <ion-col class="ion-no-padding">
      <p class="ion-text-right">
        <ion-skeleton-text animated></ion-skeleton-text>
      </p>
    </ion-col>
  </ion-row>
  <p>
    <ion-skeleton-text animated></ion-skeleton-text>
  </p>
</ion-content>
